import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';


export default withStyles(theme => ({
  quote: {
    margin: '0 auto',
    padding: `${theme.spacing.unit * 4}px ${theme.spacing.unit * 2}px`,
    borderTop: `2px solid ${theme.palette.primary.main}`,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    textAlign: 'center',
  },
  quoteText: {
    margin: '0 auto',
    ...theme.typography.hg36l(theme),
  },
  source: {
    color: theme.palette.secondary.light,
    marginTop: theme.spacing.unit * 2,
    ...theme.typography.hg20r(theme),
  }
}))(props => {
  const {classes, text, source, className, textMaxWidth, ...otherProps} = props;

  return (
    <div className={classNames(classes.quote, className)} {...otherProps}>
      <div className={classes.quoteText} style={{maxWidth: textMaxWidth}}>
        {text}
      </div>
      {source && <div className={classes.source}>
        {source}
      </div>}
    </div>
  )
});



// WEBPACK FOOTER //
// ./src/parts/Quote.js